import { gql } from '@apollo/client';
import PRODUCT_FRAGMENT from './product';
import PRODUCT_CURRICULUM_FRAGMENT from './product-curriculum';

const USER_TRIAL_USAGE_FRAGMENT = gql`
  fragment BaseUserTrialUsage on UserTrialUsage {
    productId
    productCurriculumId
    product {
      ...BaseProduct
    }
    productCurriculum {
      ...BaseProductCurriculum
    }
    active
    available
    dateExpiration
  }
  ${PRODUCT_FRAGMENT}
  ${PRODUCT_CURRICULUM_FRAGMENT}
`;

export default USER_TRIAL_USAGE_FRAGMENT;
